import md5 from "md5"
import {encryptPGPMessage, decryptPGPMessage} from "../business/encryption/pgp"
import {base64ToUtf8, encodeBase64} from "../utils/utils";
import StateManager from "../redux/StateManager";
import _ from "lodash";
import {HTML_MESSAGE_IDENTIFIER} from "../utils/constants";

const attachmentNamesSeparator = md5("ATTACHMENT_NAMES")
const attachmentSeparator = md5("ATTACHMENTS")

export async function encryptMessage({
                                         subject,
                                         body,
                                         attachments,
                                         isHtml,
                                         publicKeys
                                     }) {
    if (isHtml) {
        body = encodeBase64(body);
        body = `BASE64_HTML_${body}`
    }

    let attachmentNames = ""

    attachments.forEach((attachmentName) => {
        console.log(attachmentName)
        attachmentNames += `${attachmentName.name}/`
    })

    console.log(attachmentNames)

    let encryptionResults = await Promise.all([
        encryptPGPMessage(publicKeys, body),
        encryptPGPMessage(publicKeys, subject),
        encryptPGPMessage(publicKeys, attachmentNames),
    ])

    body = encryptionResults[0]
    const bodySeparator = md5("BODY")
    subject = encryptionResults[1].replaceAll("\n", "@")
    attachmentNames = encryptionResults[2]
    body = `${bodySeparator}${body}${attachmentNamesSeparator}${attachmentNames}${attachmentNamesSeparator}${bodySeparator}${attachmentSeparator}`
    let atcEncryptPromises = []
    attachments.forEach((file) => {
        const mimeFormatted =
            `Content-Type: ${file.type}; name="${file.name}"\r\n` +
            `Content-Disposition: attachment; filename="${file.name}"\r\n` +
            `Content-Transfer-Encoding: base64\r\n\r\n` +
            `${file.content}`;

        atcEncryptPromises.push(encryptPGPMessage(publicKeys, mimeFormatted));
    })

    let atcEncryptResults = await Promise.all(atcEncryptPromises)

    atcEncryptResults.forEach((encAttachment, key) => {
        let attachmentName = md5(attachments[key].name)
        body += attachmentName;
        body += encAttachment
        body += attachmentName;
    })
    return {body, encryptedSubject: subject}
}

export const MailFieldsForCache = {
    uid: "uid",
    from: "from",
    to: "to",
    isEncrypted: "isEncrypted",
    subject: "subject",
    body: "body",
    attachmentNames: "attachmentNames",
    references: "references",
    isReplyTo: "isReplyTo",
    words: "words",
    date: "date",
    threadId: "threadId",
    createdAt: "createdAt",
    intendedFor: "intendedFor",
    timestamp: "timestamp",
    internal:"internal"
}

export async function decryptMessageBody(message) {
    if (message.isEncrypted && !_.isEmpty(message.body)) {
        return decryptPGPMessage(StateManager.getPrivateKey(), StateManager.getPassphrase(), message.body)
    } else {
        return message.body
    }
}

export async function decryptMessageSubject(message) {
    if (message.isEncrypted && !_.isEmpty(message.subject)) {
        let subject = message.subject
        subject = subject.replaceAll("@", "\n")
        return decryptPGPMessage(StateManager.getPrivateKey(), StateManager.getPassphrase(), subject)
    } else {
        return message.subject
    }
}

export async function decryptMessageAttachmentNames(message) {
    if (message.isEncrypted && !_.isEmpty(message.attachmentNames)) {
        return decryptPGPMessage(StateManager.getPrivateKey(), StateManager.getPassphrase(), message.attachmentNames)
    } else {
        console.log("I am here sarkar")
        return message.attachmentNames
    }
}

export async function parseMessageForCache(box, mailObject) {
    if (_.isEmpty(mailObject.from)) {
        return
    }
    let [subject, body, attachmentNames] = await Promise.all([
        decryptMessageSubject(mailObject),
        decryptMessageBody(mailObject),
        decryptMessageAttachmentNames(mailObject),
    ])

    if (body.startsWith(HTML_MESSAGE_IDENTIFIER)) {
        body = base64ToUtf8(body.split(HTML_MESSAGE_IDENTIFIER)[1])
        body = extractTextFromHTML(body)
    }

    body = body.replace(/[^\w\s]/g, '').replace(/\s+/g, ' ');
    subject = subject.replace(/[^\w\s]/g, '').replace(/\s+/g, ' ');


    let words
    words = [...subject.split(" "), ...attachmentNames.split("/"), ...body.split(" ")]

    words = words.filter(item => item !== "")

    words = [...new Set(words)]

    let formattedWords = []
    words.forEach((word) => {
        formattedWords.push(md5(word.toLowerCase()))
    })
    formattedWords.push(md5(mailObject.from))

    mailObject.timestamp = new Date(mailObject.date).getTime();

    let cacheObject = {
        ...mailObject,
        words: formattedWords.join(",")
    }

    return {box, cacheObject}
}

function extractTextFromHTML(htmlString) {
    const tempElement = document.createElement('div');
    tempElement.innerHTML = htmlString;
    return tempElement.textContent || tempElement.innerText || '';
}

export function extractEmail(input) {
    const match = input.match(/<([^>]+)>|([^<>\s"]+@[^\s"<>]+)/);
    return match ? (match[1] || match[2]) : null;
}


export const decodeIfMimeEncoded = (input) => {
    const mimePattern = /=\?utf-8\?([bq])\?(.*?)\?=/gi;

    if (!mimePattern.test(input)) return input;

    return input.replace(mimePattern, (_, encoding, encodedText) => {
        if (encoding.toLowerCase() === "q") {
            // Handle "Q" (Quoted-Printable) encoding
            return encodedText
                .replace(/_/g, ' ') // Replace underscores with spaces
                .replace(/=([A-Fa-f0-9]{2})/g, (_, hex) => String.fromCharCode(parseInt(hex, 16))); // Decode hex
        } else if (encoding.toLowerCase() === "b") {
            // Handle "B" (Base64) encoding
            return decodeURIComponent(escape(atob(encodedText)));
        }
        return input; // Return as is if not recognized
    });
};


export const createSubstring = (string, neededLength) => {
    if (string.length > neededLength)
        return `${string.substring(0, neededLength)}...`
    else
        return string
}





